import { RecaptchaType } from '@hooks/use-remote-config/types/recaptcha';

export const defaultRecaptchaValues: { web_recaptcha: RecaptchaType } = {
  web_recaptcha: {
    data: { signIn: false, signUp: false, forgotEmail: false, editEmail: false },
  },
};
